import * as a from '@/libs/a'

/**
 * router.push() の機能を拡張し、移動先がすでに履歴にあれば
 * `go()` で移動する機能を追加する
 *
 * @param {Router} router
 * @param {Store} store
 */
export default function extend (router, store) {
  // オリジナルの push() を保存する
  const savedPush = router.push

  // 機能拡張した push を定義する
  router.push = function push (location) {
    const resolve = Promise.resolve()

    // location.hash = '#' なら、オリジナルの push() を使用する
    if (a.prop(location, 'hash') === '#') {
      delete location.hash
      return savedPush.call(this, location)
    }

    // location.hash = '#back' なら、1つ前に戻る
    if (a.prop(location, 'hash') === '#back') {
      router.back()
      // this.back()
      return resolve
    }

    // location を path などを解決する
    const resolved = router.resolve(location)

    // 履歴に location のパスがあるか
    const historyIndex = store.getters['history/findIndex'](resolved.route.fullPath)
    const currentIndex = store.getters['history/currentIndex']
    // const all = store.getters['history/allHistory']

    // console.log(resolve)
    // console.log(resolved)
    // console.log(resolved.route.fullPath)
    // console.log('ほげほげ')
    // console.log(currentIndex)
    // console.log(historyIndex)
    // console.log(all)

    // 履歴になかったので、オリジナルの push を実行する
    if (historyIndex < 0) {
      return savedPush.call(this, resolved.route)
    }

    // 現在位置を取得する
    // const currentIndex = store.getters['history/currentIndex']

    // historyIndex が現在位置なので、何もしない
    if (historyIndex === currentIndex) {
      return resolve
    }

    // go() で移動する
    // this.go(currentIndex - historyIndex)
    // this.go(historyIndex * -1)
    // this.$router.replace(resolved.route.fullPath)
    // this.goTo(resolved.route.fullPath)
    router.replace(location)

    return resolve
  }
}
